module.exports = __webpack_public_path__ + "static/media/useSelections_on.92bcaef6.jpg";